import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pl-2 pt-2" }
const _hoisted_2 = {
  key: 0,
  class: "default_card_wm pt-2"
}
const _hoisted_3 = { class: "d-flex justify-space-between" }
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "flex-grow-1" }
const _hoisted_6 = { class: "d-flex flex-grow-0 flex-shrink-1" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_DocumentDropDown = _resolveComponent("DocumentDropDown")!
  const _component_DocumentFileViewer = _resolveComponent("DocumentFileViewer")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_AccountingItemStatic = _resolveComponent("AccountingItemStatic")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_SelectUser = _resolveComponent("SelectUser")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_oss_date_picker = _resolveComponent("oss-date-picker")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_oss_text_field = _resolveComponent("oss-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_DocumentValidationSpeedRun = _resolveComponent("DocumentValidationSpeedRun")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          sm: "6"
        }, {
          default: _withCtx(() => [
            (_ctx.document.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      (!_ctx.$vuetify.display.mobile && _ctx.mode != 'GeneralLedger' && _ctx.goBackHistory)
                        ? (_openBlock(), _createBlock(_component_v_btn_back, {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.back()), ["stop"]))
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.isPDF)
                        ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                            key: 1,
                            icon: "$oss-zoom-out",
                            disabled: _ctx.zoomManager.disableZoomOut(),
                            class: "btn mr-1",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.zoomManager.zoomOut()), ["stop"]))
                          }, null, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (!_ctx.isPDF)
                        ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                            key: 2,
                            icon: "$oss-focus",
                            disabled: _ctx.zoomManager.disableResetZoom(),
                            class: "btn mx-1",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.zoomManager.resetZoom()), ["stop"]))
                          }, null, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (!_ctx.isPDF)
                        ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                            key: 3,
                            icon: "$oss-zoom-in",
                            disabled: _ctx.zoomManager.disableZoomIn(),
                            class: "btn ml-1",
                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.zoomManager.zoomIn()), ["stop"]))
                          }, null, 8, ["disabled"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      (_ctx.activeTab === 'document')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.document.signedUrlOCR)
                              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                  key: 0,
                                  icon: "$oss-eye",
                                  disabled: _ctx.zoomManager.disableResetZoom(),
                                  class: "btn ml-1",
                                  color: _ctx.showOCR ? 'primary' : 'secondary',
                                  loading: _ctx.ocrLoading,
                                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.onOCRChanged()), ["stop"])),
                                  size: "small"
                                }, null, 8, ["disabled", "color", "loading"]))
                              : _createCommentVNode("", true),
                            _withDirectives(_createVNode(_component_v_text_field_filled, {
                              modelValue: _ctx.selectedText,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedText) = $event)),
                              id: "selectedText",
                              "hide-details": "",
                              class: "ml-2 small-prepend-icon",
                              "append-inner-icon": "$oss-close",
                              block: "",
                              density: "compact",
                              "onClick:appendInner": _ctx.emptySelectedText
                            }, null, 8, ["modelValue", "onClick:appendInner"]), [
                              [_vShow, _ctx.selectedText]
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                      _createVNode(_component_DocumentDropDown, _mergeProps({
                                    document: _ctx.document,
                                    isIncomingOutgoingPayment: _ctx.isIncomingOutgoingPayment,
                                    restartAnalysis: _ctx.restartAnalysis,
                                    disabledDelete: _ctx.disabledDelete,
                                }, {
                        showAccountingLines: _ctx.showAccountingLines,
                        "onUpdate:showAccountingLines": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showAccountingLines) = $event)),
                        activeTab: _ctx.activeTab,
                        "onUpdate:activeTab": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.activeTab) = $event)),
                        accountingLinesLockedDialog: _ctx.accountingLinesLockedDialog,
                        "onUpdate:accountingLinesLockedDialog": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.accountingLinesLockedDialog) = $event)),
                        analyseDocumentDialog: _ctx.analyseDocumentDialog,
                        "onUpdate:analyseDocumentDialog": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.analyseDocumentDialog) = $event)),
                        deleteDocumentDialog: _ctx.deleteDocumentDialog,
                        "onUpdate:deleteDocumentDialog": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.deleteDocumentDialog) = $event))
                      }), null, 16, ["showAccountingLines", "activeTab", "accountingLinesLockedDialog", "analyseDocumentDialog", "deleteDocumentDialog"])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_v_window, {
                      modelValue: _ctx.activeTab,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.activeTab) = $event)),
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_window_item, { value: "document" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DocumentFileViewer, _mergeProps({ document: _ctx.document }, {
                              svgVariants: _ctx.svgVariants,
                              showOCR: _ctx.showOCR,
                              ocr: _ctx.ocr,
                              onShowCorrespondingField: _ctx.showCorrespondingField,
                              onTokenClick: _ctx.onClickToken
                            }), null, 16, ["svgVariants", "showOCR", "ocr", "onShowCorrespondingField", "onTokenClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: "accountingLines" }, {
                          default: _withCtx(() => [
                            (_ctx.document.id)
                              ? (_openBlock(), _createBlock(_component_AccountingItemStatic, {
                                  companyId: _ctx.companyId,
                                  documentId: _ctx.document.id,
                                  mode: _ctx.isAccountingItem ? 'AllOption' : 'Embedded',
                                  ref: "accountingItemStatic",
                                  key: _ctx.accountingLinesRefreshKey,
                                  onUpsert: _ctx.onAccountingItemUpdated
                                }, null, 8, ["companyId", "documentId", "mode", "onUpsert"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: "activity" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_UsersActivitiesHistory, {
                              documentId: _ctx.document.id
                            }, null, 8, ["documentId"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          sm: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "default_card_wm elevation-0 rounded-l-2 rounded-r-0 fill-height" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "ma-1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, {
                              "single-line": "",
                              class: "pt-0",
                              density: "compact"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item, {
                                  ripple: false,
                                  class: "mb-2",
                                  color: "success",
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.userDialog = true))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex align-center",
                                              style: {"border-right":"1px #ededed solid"}
                                            }, {
                                              default: _withCtx(() => _cache[102] || (_cache[102] = [
                                                _createElementVNode("b", null, "Collaborateur", -1)
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "9",
                                              class: "d-flex align-center pl-2 justify-space-between"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", null, _toDisplayString(_ctx.getUserDisplayName(_ctx.currentAccountUser)), 1),
                                                _createVNode(_component_v_icon, { size: "small" }, {
                                                  default: _withCtx(() => _cache[103] || (_cache[103] = [
                                                    _createTextVNode("$oss-edit")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.userDialog)
                              ? (_openBlock(), _createBlock(_component_oss_dialog, {
                                  key: 0,
                                  modelValue: _ctx.userDialog,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.userDialog) = $event)),
                                  fullscreen: _ctx.$vuetify.display.mobile,
                                  title: 'Choissez une personne',
                                  onValid: _cache[15] || (_cache[15] = ($event: any) => (_ctx.userDialog = false)),
                                  validDisabled: !_ctx.currentAccountUser || !_ctx.currentAccountUser.id,
                                  validLoading: _ctx.validLoading,
                                  width: "800px"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_SelectUser, {
                                      modelValue: _ctx.currentAccountUser,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.currentAccountUser) = $event)),
                                      companyId: _ctx.companyId
                                    }, null, 8, ["modelValue", "companyId"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "fullscreen", "validDisabled", "validLoading"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.form['date'])
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          "no-gutters": "",
                          class: "ma-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "d-flex",
                              style: {"flex-wrap":"nowrap"}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                  _createVNode(_component_oss_date_picker, {
                                    "hide-details": true,
                                    label: _ctx.$t('shared.date'),
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (
                                            _ctx.onDateChange(_ctx.form['date'], 'date', $event)
                                        )),
                                    onMouseover: _cache[17] || (_cache[17] = ($event: any) => (_ctx.highlightField(_ctx.form.date, true))),
                                    onMouseout: _cache[18] || (_cache[18] = ($event: any) => (_ctx.highlightField(_ctx.form.date, false))),
                                    mandatory: false,
                                    textFieldReadOnly: false,
                                    prefixDataCy: 'DocumentValidationPaySlip-date-',
                                    "model-value": _ctx.formatDate(_ctx.form['date'].value)
                                  }, null, 8, ["label", "model-value"])
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_component_v_btn, {
                                    color: 
                                            _ctx.form.date && _ctx.form.date.validated ? 'primary' : 'red'
                                        ,
                                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.validateDateField(_ctx.form.date, 'date')))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, { size: "small" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.form.date && _ctx.form.date.validated
                                                    ? "$oss-circle-check"
                                                    : "$oss-circle-uncheck"), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["color"])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_divider, { class: "my-2" }),
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field, _mergeProps({
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.onMetadataChange(_ctx.form, 'grossSalary'))),
                              onMouseover: _cache[21] || (_cache[21] = ($event: any) => (_ctx.highlightField(_ctx.form.grossSalary, true))),
                              onMouseout: _cache[22] || (_cache[22] = ($event: any) => (_ctx.highlightField(_ctx.form.grossSalary, false))),
                              "append-outer-icon": 
                                        _ctx.form.grossSalary.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    ,
                              "onClick:appendOuter": _cache[23] || (_cache[23] = ($event: any) => (
                                        _ctx.form.grossSalary.validated = !_ctx.form['grossSalary'].validated
                                    ))
                            }, _ctx.ossTextFieldCommonBind, {
                              modelValue: _ctx.form.grossSalary.value,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.grossSalary.value) = $event))
                            }), {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("document.social.grossSalary")) + " ", 1),
                                (_ctx.confidence(_ctx.form.grossSalary))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                      _cache[104] || (_cache[104] = _createTextVNode(" ( ")),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(
                                                    _ctx.confidence(_ctx.form.grossSalary) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                )
                                      }, _toDisplayString(`${_ctx.confidence(_ctx.form.grossSalary)}%`), 3),
                                      _cache[105] || (_cache[105] = _createTextVNode(") "))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 16, ["append-outer-icon", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field, _mergeProps({
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.onMetadataChange(_ctx.form, 'salaryCharges'))),
                              onMouseover: _cache[26] || (_cache[26] = ($event: any) => (_ctx.highlightField(_ctx.form.salaryCharges, true))),
                              onMouseout: _cache[27] || (_cache[27] = ($event: any) => (_ctx.highlightField(_ctx.form.salaryCharges, false))),
                              "append-outer-icon": 
                                        _ctx.form.salaryCharges.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    ,
                              "onClick:appendOuter": _cache[28] || (_cache[28] = ($event: any) => (
                                        _ctx.form.salaryCharges.validated = !_ctx.form.salaryCharges.validated
                                    ))
                            }, _ctx.ossTextFieldCommonBind, {
                              modelValue: _ctx.form.salaryCharges.value,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.salaryCharges.value) = $event))
                            }), {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("document.social.salaryCharges")) + " ", 1),
                                (_ctx.confidence(_ctx.form.salaryCharges))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                      _cache[106] || (_cache[106] = _createTextVNode(" ( ")),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(
                                                    _ctx.confidence(_ctx.form.salaryCharges) > 80
                                                        ? ''
                                                        : 'text-red'
                                                )
                                      }, _toDisplayString(`${_ctx.confidence(_ctx.form.salaryCharges)}%`), 3),
                                      _cache[107] || (_cache[107] = _createTextVNode(") "))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 16, ["append-outer-icon", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field, _mergeProps({
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.onMetadataChange(_ctx.form, 'employerCharges'))),
                              onMouseover: _cache[31] || (_cache[31] = ($event: any) => (_ctx.highlightField(_ctx.form.employerCharges, true))),
                              onMouseout: _cache[32] || (_cache[32] = ($event: any) => (_ctx.highlightField(_ctx.form.employerCharges, false))),
                              "append-outer-icon": 
                                        _ctx.form.employerCharges.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    ,
                              "onClick:appendOuter": _cache[33] || (_cache[33] = ($event: any) => (
                                        _ctx.form.employerCharges.validated =
                                            !_ctx.form.employerCharges.validated
                                    ))
                            }, _ctx.ossTextFieldCommonBind, {
                              modelValue: _ctx.form.employerCharges.value,
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.employerCharges.value) = $event))
                            }), {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("document.social.employerCharges")) + " ", 1),
                                (_ctx.confidence(_ctx.form.employerCharges))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                      _cache[108] || (_cache[108] = _createTextVNode(" ( ")),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(
                                                    _ctx.confidence(_ctx.form.employerCharges) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                )
                                      }, _toDisplayString(`${_ctx.confidence(_ctx.form.employerCharges)}%`), 3),
                                      _cache[109] || (_cache[109] = _createTextVNode(") "))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 16, ["append-outer-icon", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field, _mergeProps({
                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (
                                        _ctx.onMetadataChange(_ctx.form, 'nonDeductibleCSGCRDS')
                                    )),
                              onMouseover: _cache[36] || (_cache[36] = ($event: any) => (_ctx.highlightField(_ctx.form.nonDeductibleCSGCRDS, true))),
                              onMouseout: _cache[37] || (_cache[37] = ($event: any) => (_ctx.highlightField(_ctx.form.nonDeductibleCSGCRDS, false))),
                              "append-outer-icon": 
                                        _ctx.form.nonDeductibleCSGCRDS.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    ,
                              "onClick:appendOuter": _cache[38] || (_cache[38] = ($event: any) => (
                                        _ctx.form.nonDeductibleCSGCRDS.validated =
                                            !_ctx.form.nonDeductibleCSGCRDS.validated
                                    ))
                            }, _ctx.ossTextFieldCommonBind, {
                              modelValue: _ctx.form.nonDeductibleCSGCRDS.value,
                              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.form.nonDeductibleCSGCRDS.value) = $event))
                            }), {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("document.social.nonDeductibleCSGCRDS")) + " ", 1),
                                (_ctx.confidence(_ctx.form.nonDeductibleCSGCRDS))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                      _cache[110] || (_cache[110] = _createTextVNode(" ( ")),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(
                                                    _ctx.confidence(_ctx.form.nonDeductibleCSGCRDS) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                )
                                      }, _toDisplayString(`${_ctx.confidence(_ctx.form.nonDeductibleCSGCRDS)}%`), 3),
                                      _cache[111] || (_cache[111] = _createTextVNode(") "))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 16, ["append-outer-icon", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field, _mergeProps({
                              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.onMetadataChange(_ctx.form, 'hshc'))),
                              onMouseover: _cache[41] || (_cache[41] = ($event: any) => (_ctx.highlightField(_ctx.form.hshc, true))),
                              onMouseout: _cache[42] || (_cache[42] = ($event: any) => (_ctx.highlightField(_ctx.form.hshc, false))),
                              "append-outer-icon": 
                                        _ctx.form.hshc.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    ,
                              "onClick:appendOuter": _cache[43] || (_cache[43] = ($event: any) => (_ctx.form.hshc.validated = !_ctx.form.hshc.validated))
                            }, _ctx.ossTextFieldCommonBind, {
                              modelValue: _ctx.form.hshc.value,
                              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.form.hshc.value) = $event))
                            }), {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("document.social.hshc")) + " ", 1),
                                (_ctx.confidence(_ctx.form.hshc))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                      _cache[112] || (_cache[112] = _createTextVNode(" ( ")),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(
                                                    _ctx.confidence(_ctx.form.hshc) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                )
                                      }, _toDisplayString(`${_ctx.confidence(_ctx.form.hshc)}%`), 3),
                                      _cache[113] || (_cache[113] = _createTextVNode(") "))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 16, ["append-outer-icon", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field, _mergeProps({
                              "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_ctx.onMetadataChange(_ctx.form, 'navigo'))),
                              onMouseover: _cache[46] || (_cache[46] = ($event: any) => (_ctx.highlightField(_ctx.form.navigo, true))),
                              onMouseout: _cache[47] || (_cache[47] = ($event: any) => (_ctx.highlightField(_ctx.form.navigo, false))),
                              "append-outer-icon": 
                                        _ctx.form.navigo.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    ,
                              "onClick:appendOuter": _cache[48] || (_cache[48] = ($event: any) => (
                                        _ctx.form.navigo.validated = !_ctx.form.navigo.validated
                                    ))
                            }, _ctx.ossTextFieldCommonBind, {
                              modelValue: _ctx.form.navigo.value,
                              "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.form.navigo.value) = $event))
                            }), {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("document.social.navigo")) + " ", 1),
                                (_ctx.confidence(_ctx.form.navigo))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                      _cache[114] || (_cache[114] = _createTextVNode(" ( ")),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(
                                                    _ctx.confidence(_ctx.form.navigo) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                )
                                      }, _toDisplayString(`${_ctx.confidence(_ctx.form.navigo)}%`), 3),
                                      _cache[115] || (_cache[115] = _createTextVNode(") "))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 16, ["append-outer-icon", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field, _mergeProps({
                              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (_ctx.onMetadataChange(_ctx.form, 'benefitInKind'))),
                              onMouseover: _cache[51] || (_cache[51] = ($event: any) => (_ctx.highlightField(_ctx.form.benefitInKind, true))),
                              onMouseout: _cache[52] || (_cache[52] = ($event: any) => (_ctx.highlightField(_ctx.form.benefitInKind, false))),
                              "append-outer-icon": 
                                        _ctx.form.benefitInKind.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    ,
                              "onClick:appendOuter": _cache[53] || (_cache[53] = ($event: any) => (
                                        _ctx.form.benefitInKind.validated = !_ctx.form.benefitInKind.validated
                                    ))
                            }, _ctx.ossTextFieldCommonBind, {
                              modelValue: _ctx.form.benefitInKind.value,
                              "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.form.benefitInKind.value) = $event))
                            }), {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("document.social.benefitInKind")) + " ", 1),
                                (_ctx.confidence(_ctx.form.benefitInKind))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                      _cache[116] || (_cache[116] = _createTextVNode(" ( ")),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(
                                                    _ctx.confidence(_ctx.form.benefitInKind) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                )
                                      }, _toDisplayString(`${_ctx.confidence(_ctx.form.benefitInKind)}%`), 3),
                                      _cache[117] || (_cache[117] = _createTextVNode(") "))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 16, ["append-outer-icon", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field, _mergeProps({
                              "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => (_ctx.onMetadataChange(_ctx.form, 'luncheonVoucher'))),
                              onMouseover: _cache[56] || (_cache[56] = ($event: any) => (_ctx.highlightField(_ctx.form.luncheonVoucher, true))),
                              onMouseout: _cache[57] || (_cache[57] = ($event: any) => (_ctx.highlightField(_ctx.form.luncheonVoucher, false))),
                              "append-outer-icon": 
                                        _ctx.form.luncheonVoucher.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    ,
                              "onClick:appendOuter": _cache[58] || (_cache[58] = ($event: any) => (
                                        _ctx.form.luncheonVoucher.validated =
                                            !_ctx.form.luncheonVoucher.validated
                                    ))
                            }, _ctx.ossTextFieldCommonBind, {
                              modelValue: _ctx.form.luncheonVoucher.value,
                              "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.form.luncheonVoucher.value) = $event))
                            }), {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("document.social.luncheonVoucher")) + " ", 1),
                                (_ctx.confidence(_ctx.form.luncheonVoucher))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                      _cache[118] || (_cache[118] = _createTextVNode(" ( ")),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(
                                                    _ctx.confidence(_ctx.form.luncheonVoucher) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                )
                                      }, _toDisplayString(`${_ctx.confidence(_ctx.form.luncheonVoucher)}%`), 3),
                                      _cache[119] || (_cache[119] = _createTextVNode(") "))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 16, ["append-outer-icon", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field, _mergeProps({
                              "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => (_ctx.onMetadataChange(_ctx.form, 'employerLoan'))),
                              onMouseover: _cache[61] || (_cache[61] = ($event: any) => (_ctx.highlightField(_ctx.form.employerLoan, true))),
                              onMouseout: _cache[62] || (_cache[62] = ($event: any) => (_ctx.highlightField(_ctx.form.employerLoan, false))),
                              "append-outer-icon": 
                                        _ctx.form.employerLoan.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    ,
                              "onClick:appendOuter": _cache[63] || (_cache[63] = ($event: any) => (
                                        _ctx.form.employerLoan.validated = !_ctx.form.employerLoan.validated
                                    ))
                            }, _ctx.ossTextFieldCommonBind, {
                              modelValue: _ctx.form.employerLoan.value,
                              "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.form.employerLoan.value) = $event))
                            }), {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("document.social.employerLoan")) + " ", 1),
                                (_ctx.confidence(_ctx.form.employerLoan))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                      _cache[120] || (_cache[120] = _createTextVNode(" ( ")),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(
                                                    _ctx.confidence(_ctx.form.employerLoan) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                )
                                      }, _toDisplayString(`${_ctx.confidence(_ctx.form.employerLoan)}%`), 3),
                                      _cache[121] || (_cache[121] = _createTextVNode(") "))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 16, ["append-outer-icon", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field, _mergeProps({
                              "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => (
                                        _ctx.onMetadataChange(_ctx.form, 'thirdPartyNotification')
                                    )),
                              onMouseover: _cache[66] || (_cache[66] = ($event: any) => (_ctx.highlightField(_ctx.form.thirdPartyNotification, true))),
                              onMouseout: _cache[67] || (_cache[67] = ($event: any) => (_ctx.highlightField(_ctx.form.thirdPartyNotification, false))),
                              "append-outer-icon": 
                                        _ctx.form.thirdPartyNotification.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    ,
                              "onClick:appendOuter": _cache[68] || (_cache[68] = ($event: any) => (
                                        _ctx.form.thirdPartyNotification.validated =
                                            !_ctx.form.thirdPartyNotification.validated
                                    ))
                            }, _ctx.ossTextFieldCommonBind, {
                              modelValue: _ctx.form.thirdPartyNotification.value,
                              "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.form.thirdPartyNotification.value) = $event))
                            }), {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("document.social.thirdPartyNotification")) + " ", 1),
                                (_ctx.confidence(_ctx.form.thirdPartyNotification))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                      _cache[122] || (_cache[122] = _createTextVNode(" ( ")),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(
                                                    _ctx.confidence(_ctx.form.thirdPartyNotification) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                )
                                      }, _toDisplayString(`${_ctx.confidence(_ctx.form.thirdPartyNotification)}%`), 3),
                                      _cache[123] || (_cache[123] = _createTextVNode(") "))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 16, ["append-outer-icon", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field, _mergeProps({
                              "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => (
                                        _ctx.onMetadataChange(_ctx.form, 'netSalaryBeforeTax')
                                    )),
                              onMouseover: _cache[71] || (_cache[71] = ($event: any) => (_ctx.highlightField(_ctx.form.netSalaryBeforeTax, true))),
                              onMouseout: _cache[72] || (_cache[72] = ($event: any) => (_ctx.highlightField(_ctx.form.netSalaryBeforeTax, false))),
                              "append-outer-icon": 
                                        _ctx.form.netSalaryBeforeTax.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    ,
                              "onClick:appendOuter": _cache[73] || (_cache[73] = ($event: any) => (
                                        _ctx.form.netSalaryBeforeTax.validated =
                                            !_ctx.form.netSalaryBeforeTax.validated
                                    ))
                            }, _ctx.ossTextFieldCommonBind, {
                              modelValue: _ctx.form.netSalaryBeforeTax.value,
                              "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.form.netSalaryBeforeTax.value) = $event))
                            }), {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("document.social.netSalaryBeforeTax")) + " ", 1),
                                (_ctx.confidence(_ctx.form.netSalaryBeforeTax))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                      _cache[124] || (_cache[124] = _createTextVNode(" ( ")),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(
                                                    _ctx.confidence(_ctx.form.netSalaryBeforeTax) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                )
                                      }, _toDisplayString(`${_ctx.confidence(_ctx.form.netSalaryBeforeTax)}%`), 3),
                                      _cache[125] || (_cache[125] = _createTextVNode(") "))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 16, ["append-outer-icon", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field, _mergeProps({
                              "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => (_ctx.onMetadataChange(_ctx.form, 'incomeTax'))),
                              onMouseover: _cache[76] || (_cache[76] = ($event: any) => (_ctx.highlightField(_ctx.form.incomeTax, true))),
                              onMouseout: _cache[77] || (_cache[77] = ($event: any) => (_ctx.highlightField(_ctx.form.incomeTax, false))),
                              "append-outer-icon": 
                                        _ctx.form.incomeTax.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    ,
                              "onClick:appendOuter": _cache[78] || (_cache[78] = ($event: any) => (
                                        _ctx.form.incomeTax.validated = !_ctx.form.incomeTax.validated
                                    ))
                            }, _ctx.ossTextFieldCommonBind, {
                              modelValue: _ctx.form.incomeTax.value,
                              "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.form.incomeTax.value) = $event))
                            }), {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("document.social.incomeTax")) + " ", 1),
                                (_ctx.confidence(_ctx.form.incomeTax))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                      _cache[126] || (_cache[126] = _createTextVNode(" ( ")),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(
                                                    _ctx.confidence(_ctx.form.incomeTax) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                )
                                      }, _toDisplayString(`${_ctx.confidence(_ctx.form.incomeTax)}%`), 3),
                                      _cache[127] || (_cache[127] = _createTextVNode(") "))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 16, ["append-outer-icon", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field, _mergeProps({
                              "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => (_ctx.onMetadataChange(_ctx.form, 'netSalaryPaid'))),
                              onMouseover: _cache[81] || (_cache[81] = ($event: any) => (_ctx.highlightField(_ctx.form.netSalaryPaid, true))),
                              onMouseout: _cache[82] || (_cache[82] = ($event: any) => (_ctx.highlightField(_ctx.form.netSalaryPaid, false))),
                              "append-outer-icon": 
                                        _ctx.form.netSalaryPaid.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    ,
                              "onClick:appendOuter": _cache[83] || (_cache[83] = ($event: any) => (
                                        _ctx.form.netSalaryPaid.validated = !_ctx.form.netSalaryPaid.validated
                                    ))
                            }, _ctx.ossTextFieldCommonBind, {
                              modelValue: _ctx.form.netSalaryPaid.value,
                              "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.form.netSalaryPaid.value) = $event))
                            }), {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("document.social.netSalaryPaid")) + " ", 1),
                                (_ctx.confidence(_ctx.form.netSalaryPaid))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                      _cache[128] || (_cache[128] = _createTextVNode(" ( ")),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(
                                                    _ctx.confidence(_ctx.form.netSalaryPaid) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                )
                                      }, _toDisplayString(`${_ctx.confidence(_ctx.form.netSalaryPaid)}%`), 3),
                                      _cache[129] || (_cache[129] = _createTextVNode(") "))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 16, ["append-outer-icon", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field, _mergeProps({
                              "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => (_ctx.onMetadataChange(_ctx.form, 'totalCost'))),
                              onMouseover: _cache[86] || (_cache[86] = ($event: any) => (_ctx.highlightField(_ctx.form.totalCost, true))),
                              onMouseout: _cache[87] || (_cache[87] = ($event: any) => (_ctx.highlightField(_ctx.form.totalCost, false))),
                              "append-outer-icon": 
                                        _ctx.form.totalCost.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    ,
                              "onClick:appendOuter": _cache[88] || (_cache[88] = ($event: any) => (
                                        _ctx.form.totalCost.validated = !_ctx.form.totalCost.validated
                                    ))
                            }, _ctx.ossTextFieldCommonBind, {
                              modelValue: _ctx.form.totalCost.value,
                              "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => ((_ctx.form.totalCost.value) = $event))
                            }), {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("document.social.totalCost")) + " ", 1),
                                (_ctx.confidence(_ctx.form.totalCost))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                      _cache[130] || (_cache[130] = _createTextVNode(" ( ")),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(
                                                    _ctx.confidence(_ctx.form.totalCost) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                )
                                      }, _toDisplayString(`${_ctx.confidence(_ctx.form.totalCost)}%`), 3),
                                      _cache[131] || (_cache[131] = _createTextVNode(") "))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 16, ["append-outer-icon", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "ma-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_tooltip, { location: "top" }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps({
                          class: "btn",
                          rounded: "circle",
                          size: "x-small",
                          dark: "",
                          color: "primary",
                          onClick: _cache[90] || (_cache[90] = ($event: any) => (_ctx.setOpenChat('INFORMATION_REQUEST')))
                        }, props, { icon: "$fa-comments" }), null, 16)
                      ]),
                      default: _withCtx(() => [
                        _cache[132] || (_cache[132] = _createElementVNode("span", null, "Question", -1))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tooltip, { location: "top" }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps({
                          class: "btn",
                          rounded: "circle",
                          onClick: _cache[91] || (_cache[91] = ($event: any) => (_ctx.setOpenChat('DENIED'))),
                          size: "x-small"
                        }, props, { icon: "report_problem" }), null, 16)
                      ]),
                      default: _withCtx(() => [
                        _cache[133] || (_cache[133] = _createElementVNode("span", null, "Rejeter", -1))
                      ]),
                      _: 1
                    }),
                    (_ctx.activateReconciliation)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          location: "top"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps({
                              class: "btn",
                              rounded: "circle",
                              size: "x-small",
                              dark: "",
                              color: "primary",
                              onClick: _cache[92] || (_cache[92] = ($event: any) => (_ctx.openReconciliation()))
                            }, props, { icon: "$compare_arrows" }), null, 16)
                          ]),
                          default: _withCtx(() => [
                            _cache[134] || (_cache[134] = _createElementVNode("span", null, "Rapprochement", -1))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.displayDocumentValidationSpeedRun(_ctx.document.status))
                      ? (_openBlock(), _createBlock(_component_DocumentValidationSpeedRun, {
                          key: 1,
                          modelValue: _ctx.lastDocumentValidationDone,
                          "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.lastDocumentValidationDone) = $event))
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_btn, {
                      class: "btn",
                      rounded: "",
                      disabled: _ctx.disabledValidate,
                      onClick: _cache[94] || (_cache[94] = ($event: any) => (_ctx.onFormValidation())),
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.validated ? "Validé" : "Valider") + " ", 1),
                        _withDirectives(_createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[135] || (_cache[135] = [
                            _createTextVNode("$check")
                          ])),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.validated]
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.openChat)
      ? (_openBlock(), _createBlock(_component_Chat, {
          key: 0,
          id: _ctx.document.chat ? _ctx.document.chat.id : '',
          inShowMessage: _ctx.open_chat,
          chatTitle: 'Document',
          chatSubtitle: _ctx.getChatSubTitle(),
          showSmartChat: _ctx.wishStatus !== 'DENIED',
          onMessageSent: _cache[95] || (_cache[95] = ($event: any) => (_ctx.onMessageSent($event))),
          onShowMessageChanged: _cache[96] || (_cache[96] = ($event: any) => (_ctx.onShowMessageChanged($event)))
        }, null, 8, ["id", "inShowMessage", "chatSubtitle", "showSmartChat"]))
      : _createCommentVNode("", true),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.dialogChooseDownload,
      "onUpdate:modelValue": _cache[99] || (_cache[99] = ($event: any) => ((_ctx.dialogChooseDownload) = $event)),
      title: "Télécharger le document",
      width: "80vw"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_row, { "no-gutters": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "6",
              class: "pr-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_primary, {
                  rounded: "",
                  block: "",
                  onClick: _cache[97] || (_cache[97] = ($event: any) => {
                                _ctx.dialogChooseDownload = false;
                                _ctx.downloadFile(true);
                            }),
                  size: "x-large"
                }, {
                  default: _withCtx(() => _cache[136] || (_cache[136] = [
                    _createTextVNode("Original")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "6",
              class: "pl-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_primary, {
                  rounded: "",
                  block: "",
                  onClick: _cache[98] || (_cache[98] = ($event: any) => {
                                _ctx.dialogChooseDownload = false;
                                _ctx.downloadFile(false);
                            }),
                  size: "x-large"
                }, {
                  default: _withCtx(() => _cache[137] || (_cache[137] = [
                    _createTextVNode("Marqué")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _cache[138] || (_cache[138] = _createTextVNode(" Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté). "))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.analyseDocumentDialog,
      "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => ((_ctx.analyseDocumentDialog) = $event)),
      title: "Relancer l'analyse du document",
      onValid: _ctx.analyseDocument,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[139] || (_cache[139] = [
        _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir relancer l'analyse ?", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "onValid"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.deleteDocumentDialog,
      "onUpdate:modelValue": _cache[101] || (_cache[101] = ($event: any) => ((_ctx.deleteDocumentDialog) = $event)),
      title: "Supprimer le document",
      error: true,
      onValid: _ctx.deleteDocument,
      validTitle: 'Oui je suis sûr(e)',
      validLoading: _ctx.deleteDocumentLoading,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[140] || (_cache[140] = [
        _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir supprimer le document ?", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "onValid", "validLoading"])
  ]))
}